<template>
  <div>
    <div class="mb-3">
      <div class="section-title mb-3">{{ $t("accerssrightforschedule") }}</div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Movie.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("movie", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Movie"
                variant="dropdown-curve"
                class="w-100"
                @shown="onClickMovieList"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    type="search"
                    ref="searchMoviesList"
                    name="searchMoviesList"
                    id="searchMoviesList"
                    :placeholder="$tc('searchMovie')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchMovie()"
                    v-on:keydown="onSearchMovie()"
                    v-on:search="onSearchMovie()"
                    v-model="searchMovie"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in MoviesList"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectHandler('movie', Item)"
                  >{{ Item.movie_name }}</b-dropdown-item
                >
                <b-dropdown-item @click="onSelectAll('movie')">{{
                  $t("all")
                }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-3 align-self-center mb-4">
          <multiselect
            :multiple="false"
            placeholder="Select Cinema"
            :group-select="false"
            select-label="Select"
            v-model="selectedCinema"
            label="cine_name"
            :options="cinemaList"
            deselect-label="Remove"
            track-by="cine_id"
            @select="onSelectCinema($event)"
            @remove="onRemoveCinema($event)"
          ></multiselect>
        </div>

        <div class="col-lg-2 col-xl-2 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.Date.length > 0 || selectedAllDate ? 'shift-up' : ''
              "
              >{{ $t("select") }} {{ $tc("date", 2) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Date || 'All'"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in Dates"
                  :key="ItemIndex"
                  href="#"
                  @click="onSelectHandler('date', Item)"
                  >{{ Item }}</b-dropdown-item
                >
                <b-dropdown-item @click="onSelectAll('date')"
                  >All</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-xl-1 align-self-center mb-4">
          <button
            @click.prevent.stop="getMovieBasedSchedule(true)"
            class="btn-blue m-0"
          >
            {{ $t("submit") }}
          </button>
        </div>

        <div
          class="col-lg-3 col-xl-3 align-self-center mb-4 d-flex justify-content-end"
        >
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>{{ $tc("Sr. No") }}</th>
              <th>{{ $tc("movieName") }}</th>
              <th>{{ $tc("date") }}</th>
              <th>{{ $tc("showtime") }}</th>
              <th style="text-align: center">{{ $tc("users") }}</th>
            </tr>
          </thead>

          <tbody>
            <template v-for="(movie, movieIndex) in Records">
              <tr
                v-for="(show, showIndex) in movie.Shows"
                :key="showIndex"
                :class="show.is_sch_disable == 'Y' ? 'disableSchRow' : ''"
                class="light_grey_back"
              >
                <td class="hei text-center">{{ show.srno }}</td>
                <td class="hei">
                  {{ show.movie_title }} {{ show.language_name }}
                  {{ show.movie_format }}
                </td>
                <td class="hei">{{ show.ss_start_date | dateparse }}</td>
                <td style="text-align: center" class="hei">
                  {{ show.ss_start_show_time }}
                </td>
                <td class="hei">
                  <multiselect
                    :disabled="!$can('update', 'Access Rights For Schedule')"
                    v-if="show.is_sch_disable == 'N'"
                    v-model="show.selectedUsers"
                    track-by="user_id"
                    label="username"
                    @select="onSelect(show, $event)"
                    @remove="onRemove(show, $event)"
                    :options="Users"
                    :multiple="true"
                  ></multiselect>
                  <div v-else class="text-center">
                    {{ "Schedule Disabled" }}
                  </div>
                </td>
              </tr>
            </template>
          </tbody>

          <tbody v-if="Records.length == 0">
            <tr>
              <td colspan="5">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  name: "access-rights-for-schedule",
  components: {
    NoRecords,
  },
  data() {
    return {
      ChangeMovie: false,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      MoviesListCopy: [],
      searchMovie: "",
      Records: [],
      TempData: [],
      selectedUsers: [],
      Users: [],
      MoviesList: [],
      Dates: [],
      selected: {
        Movie: "All",
        MovieId: "",
        Date: "",
      },
      viewingnumbers: null,
      selectedAllDate: true,
      cinemaList: [],
      selectedCinema: "",
      cinema_id: null,
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    const { md_id, date } = this.$route.query;
    this.getCinemasList();

    if (md_id) {
      this.selected.MovieId = md_id;
      this.selected.Date = date ? date : "";
      this.selectedAllDate = date ? false : true;
      // this.getMovieBasedSchedule();
      this.getMoviesList(md_id);
      if (date) {
        this.getAllShowDates(date);
      } else {
        this.getAllShowDates();
      }
    } else {
      // this.getMovieBasedSchedule();
      this.getMoviesList();
      // this.getAllShowDates();
    }
  },
  mounted() {
    this.getviewingnumber();
    this.getPosAggregatorUsers();
  },
  methods: {
    onSelectCinema(obj) {
      console.log("this.Cinemas :", obj);
      this.cinema_id = obj["cine_id"];
      this.getAllShowDates();
    },
    onRemoveCinema(obj) {
      console.log("this.Cinemas :", obj);
      this.cinema_id = null;
    },
    getCinemasList: function (cine_id) {
      this.cinemaList = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onClickMovieList() {
      console.log("onClickMovieList");
      this.$refs.searchMoviesList.focus();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getMovieBasedSchedule();
      } else {
        this.currentPage = event;
        this.getMovieBasedSchedule();
      }
    },
    onSearchMovie: function () {
      if (this.searchMovie && this.searchMovie.length > 0) {
        this.MoviesList = this.MoviesListCopy.filter((x) => {
          if (
            x.movie_title.toLowerCase().includes(this.searchMovie.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.MoviesList = this.MoviesListCopy;
      }
    },
    getMovieBasedSchedule: function (submitBtn = false) {
      if (!this.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      }
      this.Records = [];
      if (submitBtn) {
        this.currentPage = 1;
      }
      let loader = this.$loading.show();
      let payload = {
        movie_id: this.selected.MovieId,
        date: this.selected.Date,
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: this.selectedCinema ? this.selectedCinema.cine_id : "",
      };
      MasterService.GetMovieBasedSchedule(payload)
        .then((response) => {
          const { data } = response;
          loader.hide();
          if (data && data.Records && data.Records.length > 0 && data.status) {
            this.Records = data.Records;
            // this.getPosAggregatorUsers();
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue =
                this.selectedvalue < 10 ? 10 : this.selectedvalue;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
            this.rows = 0;
            this.selectedvalue = this.perPage;
          }
        })
        .catch((err) => {
          loader.hide();
          this.$toasted.show(err);
        });
    },
    getMoviesList: function (md_id) {
      let payload = {
        limit: null,
        currentPage: null,
      };
      MovieService.GetMovies(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult;
            this.MoviesListCopy = data.MovieListResult;
            if (md_id) {
              let selectedMovie = data.MovieListResult.find(
                (x) => x.md_id == md_id
              );
              if (selectedMovie) {
                this.selected.Movie = selectedMovie.movie_title;
                this.selected.MovieId = selectedMovie.md_id;
              }
            }
          } else {
            // Show Error Message Here
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("error :", error);
        });
    },
    getAllShowDates: function (date) {
      if (!this.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      }

      MasterService.GetAllShowDates({
        cinema_id: this.cinema_id,
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Dates = data.Records;
            if (date) {
              let selectedDate = data.Records.find((x) => x == date);
              this.selectedAllDate = false;
              this.selected.Date = selectedDate;
            }
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("error :", error);
        });
    },
    onSelectHandler: function (type, value) {
      if (type == "movie") {
        this.selected.Movie = value.movie_title;
        this.selected.MovieId = value.md_id;
        this.searchMovie = "";
        this.ChangeMovie = true;
        this.onSearchMovie();
      } else if (type == "date") {
        this.selectedAllDate = false;
        this.selected.Date = value;
      }
    },
    onSelectAll: function (type) {
      if (type == "movie") {
        this.selected.MovieId = null;
        this.selected.Movie = "All";
      } else if (type == "date") {
        this.selected.Date = "";
        this.selectedAllDate = true;
      }
    },

    getPosAggregatorUsers: function () {
      MasterService.GetPosAggregatorUsers()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Users = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    onRemove: function (show, event) {
      if (!this.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      }

      let request_payload = {
        md_id: show.md_id,
        ss_id: show.ss_id,
        aggregator_user_id: event.user_id,
        asm_is_active: true,
        cinema_id: this.cinema_id,
      };
      MasterService.SetAccessScheduleMapping(request_payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    onSelect: function (show, event) {
      if (!this.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      }

      let request_payload = {
        md_id: show.md_id,
        ss_id: show.ss_id,
        aggregator_user_id: event.user_id,
        asm_is_active: false,
        cinema_id: this.cinema_id,
      };
      MasterService.SetAccessScheduleMapping(request_payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
  },
};
</script>

<style>
.disableSchRow {
  background-color: #d3d3d330;
  color: #a3a0a0;
  cursor: not-allowed;
}
.light_grey_back:nth-child(odd) {
  background-color: #f5f5f5;
}
.hei {
  padding: 0.35rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/AccessRightsComponents/AccessRightsForSchedule.vue